import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import ImageUploadAdapterPlugin from "../../../utils/ImageUploadAdapter";

import PageInfo from "../pageInfo";
import useUploadFiles from "../../../hooks/useUploadFiles";

import { CreateReleaseNotesContainer } from "./component/styled/dashboard";
import { Container, SubmitButton } from "../styled/mypage";

const CreateReleaseNotes = () => {
  const location = useLocation();
  const ckeditorInstanceRef = useRef(null);

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);
  const setting = useSelector((state) => state?.user?.setting);

  const { uploadFiles, extractImages, replaceSources } = useUploadFiles();

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    cmpnyNo: 16421,
    noticeDe: moment().format("YYYY-MM-DD"),
    noticeSj: "",
    noticeCn: "",
    delYn: "N",
    gbn: "DEV",
    createMberId: user.userName,
    updateMberId: user.userName,
  });

  const releaseNote = location.state?.releaseNote;

  useEffect(() => {
    if (!company.some((cmpny) => cmpny.cmpnyNo === 16421)) {
      toast.error("작성 권한이 존재하지 않습니다.");
      navigate("/");
      return;
    }

    if (releaseNote) {
      setFormData((prev) => ({
        ...prev,
        noticeNo: releaseNote.noticeNo,
        noticeDe: releaseNote.noticeDe,
        noticeSj: releaseNote.noticeSj,
        noticeCn: releaseNote.noticeCn,
      }));
    }
  }, []);

  const handleEditorChange = (_, editor) => {
    setFormData((data) => ({ ...data, noticeCn: editor.getData() }));
  };

  const handleConfirm = async () => {
    const blobs = extractImages(formData.noticeCn);
    const uploaded = await uploadFiles(blobs);
    const updated = replaceSources(
      formData.noticeCn,
      uploaded.map((f) => f.fileName),
    );
    await handleSubmit(updated);
  };

  const handleSubmit = async (noticeCn) => {
    try {
      const body = { ...formData, noticeCn };
      const res = await axios.put("/api/notice", body);
      if (res.data.success) {
        toast.success("업데이트 내용이 등록되었습니다.");
        navigate("/releaseNotes");
      }
    } catch (err) {
      console.error("등록 실패:", err);
    }
  };

  return (
    <Container className={setting?.mode}>
      <PageInfo label="개발자 노트" />
      <CreateReleaseNotesContainer className={setting?.mode}>
        <div className="content">
          <input
            type="text"
            placeholder="공지사항 제목을 입력하세요."
            name="title"
            onChange={(e) => setFormData((data) => ({ ...data, noticeSj: e.target.value }))}
            value={formData.noticeSj}
          />
          <CKEditor
            editor={ClassicEditor}
            data={formData.noticeCn}
            onChange={handleEditorChange}
            config={{
              extraPlugins: [ImageUploadAdapterPlugin],
              alignment: { options: ["center"] },
              toolbar: ["bold", "italic", "imageUpload"],
              uiSettings: { height: "500px" },
            }}
            ref={ckeditorInstanceRef}
          />
          <SubmitButton>
            <button onClick={() => handleConfirm()}>등록</button>
          </SubmitButton>
        </div>
      </CreateReleaseNotesContainer>
    </Container>
  );
};

export default CreateReleaseNotes;
